import React, {lazy, Suspense} from "react";
import {Route, Routes, useLocation} from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import styles from './styles.module.scss';
import MedicinesPage from "@/app/features/home/components/medicines";
import ChatWithDana from "@/app/features/home/components/chat_with_dana";
import CircularProgressIndicator from "@/app/components/circular_progress_indicator";
import NotesPage from "@/app/features/home/components/notes";

const Home = lazy(() => import("@/app/features/home/page"));
const NavBar = lazy(() => import("@/app/features/home/components/nav_bar"));
const MainPage = lazy(() => import("@/app/features/home/components/main_page"));
const PersonalInformationPage = lazy(() => import("@/app/features/home/components/personal_information"));
const Auth = lazy(() => import("@/app/features/auth/page"));
const Anamnesis = lazy(() => import("@/app/features/anamnesis/page"));
const MedicineDetailPage = lazy(() => import("@/app/features/home/components/medicines/medicine_detail"));
const ComparisonPage = lazy(() => import("@/app/features/home/components/comparison"));
const ProtocolsPage = lazy(() => import("@/app/features/home/components/protocols"));
const ProtocolDetailPage = lazy(() => import("@/app/features/home/components/protocols/protocol_detail"));
const ChatsPage = lazy(() => import("@/app/features/home/components/chats"));
const AddPatientToChat = lazy(() => import("@/app/features/home/components/add_patient_to_chat"));
const TranslatePage = lazy(() => import("@/app/features/home/components/translate"));

const AppRoutes: React.FC = () => {
  const location = useLocation();

  return (
    <Suspense fallback={<CircularProgressIndicator/>}>
      <div className={styles.layout}>
        {![route.auth, route.anamnesis, route.addPatientToChat].includes(location.pathname) && (
          <NavBar locationString={location.pathname}/>
        )}
        <Routes>
          <Route path={route.auth} element={<Auth/>}/>
          <Route
            path={route.home}
            element={
              <ProtectedRoute>
                <Home/>
              </ProtectedRoute>
            }
          >
            <Route index element={<MainPage/>}/>
            <Route path={route.medicines} element={<MedicinesPage/>}/>
            <Route path={route.medicineDetail + ':id_medicine'} element={<MedicineDetailPage/>}/>
            <Route path={route.profile} element={<PersonalInformationPage/>}/>
            <Route path={route.chatWithDana} element={<ChatWithDana/>}/>
            <Route path={route.comparison} element={<ComparisonPage/>}/>
            <Route path={route.protocols} element={<ProtocolsPage/>}/>
            <Route path={route.protocolsDetails + ':id'} element={<ProtocolDetailPage/>}/>
            <Route path={route.chats} element={<ChatsPage/>}/>
            <Route path={route.addPatientToChat} element={<AddPatientToChat/>}/>
            <Route path={route.translate} element={<TranslatePage/>}/>
            <Route path={route.notes} element={<NotesPage/>}/>
          </Route>
          <Route path={route.anamnesis} element={<Anamnesis/>}/>
        </Routes>
      </div>
    </Suspense>
  );
};

export default AppRoutes;

export const route = {
  home: "/",
  auth: "/auth",
  profile: "/profile",
  medicines: "/medicines",
  medicineDetail: "/medicines/",
  anamnesis: "/anamnesis",
  chatWithDana: "/chatWithDana",
  comparison: "/comparison",
  protocols: "/protocols",
  protocolsDetails: "/protocols/",
  chats: "/chats",
  addPatientToChat: "/addPatientToChat",
  translate: "/translate",
  notes: "/notes"
};